module.exports = __webpack_public_path__ + "media/images/interests/finance-3366190600f9e2e35431f7fcb0115ed3.png";